__turbopack_context__.v({
  "descriptionWrapper": "WhereToGoSectionDescription-module__bwpohq__descriptionWrapper",
  "title": "WhereToGoSectionDescription-module__bwpohq__title",
});
